import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorInvoiceOutgoingNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IInvoiceOutgoingModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
      totalWithVatEur: number,
      totalEur: number,
      debt: number,
      resetDebt: boolean,
  }

export const IInvoiceOutgoingFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges",
    "totalWithVatEur",
    "totalEur",
    "debt",
    "resetDebt"
];

export function useInvoiceOutgoingHookNae(id: number) : IInvoiceOutgoingModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorInvoiceOutgoingNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.InvoiceOutgoing.schema,
        fields: IInvoiceOutgoingFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
